import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import reportWebVitals from './reportWebVitals';
import setupStore from './redux/store';
import { setupInterceptors } from './utils/setupInterceptors';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const { store, persistor } = setupStore();
setupInterceptors(store.dispatch);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
);

reportWebVitals();
